import React from 'react';
// import { Link } from 'react-router-dom';
import { history }  from '../routers/AppRouter'
// import { compose } from 'recompose/compose';
import { connect } from 'react-redux';
import DateFnsUtils from 'material-ui-pickers/utils/date-fns-utils';
import isBefore from 'date-fns/isBefore';
import isSameDay from 'date-fns/isSameDay';
import isSameHour from 'date-fns/isSameHour';
import isSameSecond from 'date-fns/isSameSecond';
import isEmpty from 'lodash/isEmpty';
import startOfHour from 'date-fns/startOfHour';
import startOfDay from 'date-fns/startOfDay';
import { getTimezone, copyDatePart, copyTimePart } from '../utils/dateUtils';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import { DatePicker } from 'material-ui-pickers';
import { TimePicker } from 'material-ui-pickers';
import { MuiThemeProvider, createMuiTheme, ListItemSecondaryAction, Checkbox } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { differenceInHours, isSameDayWithOptions } from 'date-fns/esm/fp';
import { startSaveEventInfo } from '../actions/event';
import { clearPicAppError } from '../actions/picapp';
// import SuccessMessage from './SuccessMessage';
import { showSuccessMessage } from '../actions/event';
// import { LessThanIcon } from './icons/LessThanIcon';
// import { HomeIcon } from './icons/HomeIcon';
import { SimpleButton }  from './buttons/SimpleButton';
import { ShadowButton }  from './buttons/ShadowButton';
import { HomeIcon } from './icons/HomeIcon';

// The MuiTheme allows me to define the primary and secondary colors
// using the pallette. In addition it allows you to provide overrides
// for the various components. If you look at chrome dev tools you see
// following syntax:  MuiComponentName-cssrule-##.  For example,
// MuiInput-input-86 or MuiInput-underline-77.  The first part is the
// component name, the 2nd part is the css rule.
const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    palette: {
        primary: {
            main: '#2980B7', /* this is the blue */
        },
        secondary: {
            main: '#7F8C8D',  /* this is the greyshade4 */
            light:'yellow',
            dark: 'black'
        },
    },
    overrides: {
        MuiInput: { // Name of the component ⚛️ / style sheet
            root: { // Name of the rule (separated by dash)
                // color: 'red', // Some CSS
                width: 90,
                fontSize: 11,
            },
            input: {   // Name of the rule (separated by dash)
                paddingBottom: 0,  // eg. MuiInput-input
                // '&$focused': {
                //     backgroundColor: 'green',
                //     display: 'inline-block',
                // },
            },
            underline: {
                '&:hover:not(.disabled):not(.focused):not(.error):before': {
                        borderBottomColor: '#2980B7',
                        borderBottomWidth: '2px',
                        borderBottomStyle: 'solid'
                },
                '&:after': {
                    borderBottom: '2px solid #2980B7',
                },
            },
            // focused: {
            //     '&$focused': {
            //         backgroundColor: 'green',
            //         display: 'inline-block',
            //     }
            // }
        },
        MuiFormLabel: { // Name of the component ⚛️ / style sheet
            root: { // Name of the rule (separated by dash)
              fontSize: 15,
              fontWeight: 500,
              color: '#7F8C8D',
              lineHeight: 1,
              textAlign: 'center',
              '&$focused': {
                  color: '#2980B7'
              },

            },
            focused: {
                '&$focused': {
                    selectedTextColor: '#2980B7'
                }
            }
        },
        MuiInputLabel: { // Name of the component ⚛️ / style sheet
            root: { // Name of the rule
                color: '#7F8C8D',
            },
        },
        MuiFormControl: { // Name of the component ⚛️ / style sheet
            root: { // Name of the rule
                marginTop: 10,
            },
        },
        WithUtils: {
            DateTextFieldInput: {
             color:  'blue',

            },
        },
        MuiPickersDay: {
            day: {             // This is style for all other days other than current
              color: 'black',
              fontSize: 10,
            },
            // selected: {
            //   backgroundColor: 'yellow',
            // },
            current: {        // this is the current day
              fontSize: 10,
            },
        },
        MuiPickersCalendarHeader: {
            dayLabel: {
              fontSize: 10,   // Font size of day label (eg. Mon, Tues, Wed, etc)
            },
        },
        MuiTypography: {
            body1: {
              fontSize: 12,   // fontsize of month/yr text between month pagination
            },
        },
        MuiButton: {
            textPrimary: {
                fontSize: 11,
            }
        }
    },
});


// const theme = createMuiTheme();
// const styles =  ({
//     root: {
//         color: '#2980B7',
//         padding: 1,
//      },
//     MuiInput: {
//        color: '#2980B7',
//        padding: 1,
//     },
// });

// const theme = createMuiTheme({
//     overrides: {
//       MuiButton: { // Name of the component ⚛️ / style sheet
//         root: { // Name of the rule
//           color: 'red', // Some CSS
//         },
//       },
//     },
//   });

// import { HashLink as Link } from 'react-router-hash-link';


// const PicEventInfo = () =>  {
//     return (
//             <div className="tab-selection-panel">
//                 <h3> EventInfo </h3>
//             </div>
//     )
// }


class PicEventInfo extends React.Component {
    constructor(props) {
        super(props);



        // local component state
        this.state = {
            // id:                 this.props.picapp.selected.eventInfo.id  || '',
            email:              this.props.auth.user.email || '',
            matchEndDatetoStartDate: true,     /* used in handleStartDateChange(), refer to method for comments */
            eventTitle:         '',
            location:           '',
            // timezone:           getDateTimezone(new Date()),
            timezone:           getTimezone(),
            startDate:          new Date(),
            startTime:          startOfHour(new Date()),
            endDate:            new Date(),
            endTime:            startOfHour(new Date()),
            eventCreator:       this.props.auth.user.firstname + ' ' + this.props.auth.user.lastname,
            organizer:          '',
            organizerRadioButton: 1,
            allowAddItems:      false,
            eventMessage:       '',
            formError:          '',
            // popper related state
            anchorEl: null,
            open: true
        };

    }

    // If there is a pic application error on the redux store, clear it before unmounting component
    componentWillUnmount() {
        if (!DateFnsUtils) console.log('NO DateFnsUtils')
        if (this.props.picapp.error) {
            this.props.clearPicAppError();
        }
     }

    // Render is operating from one version of the truth - - the local component state.
    // The only time we check local storage for an active event is on componenentDidMount
    // ComponentDidMount is responsible for copying properties from local storage to local state.
    // If there is an active event in local storage(redux), initialize component state with those values,
    // otherwise, use default values set by constructor (when no event is active or created) .
    componentDidMount() {
        // If we already have an event that is active in redux, obtain the values from the redux store
        // and use them to populate local state.
        let { active: activeEvent } = this.props.event;

        /* If if alternate organizer name has been specified, set radio button 2 */


        /* note that eventCreator is initialized by the constructor using the firstname and lastname
           fields from the auth reducer. Since it comes from a different source, its not part of
           activeEvent info.  */
        if (!isEmpty(activeEvent)) {
            // Obtain values from redux
            var { id, email, eventTitle, location,
                startDate, startTime, endDate, endTime, organizer,
                /*eventCreator,*/ organizer, allowAddItems, eventMessage
            } = activeEvent;

            let organizerRadioButton = !organizer ? 1 : 2;

            // Update local state using the currently selected event in redux
            // ASSIGN VALUES TO LOCAL STATE
            this.setState({ email, eventTitle, location,
                startDate, startTime, endDate, endTime,
                /*eventCreator, */ organizer, allowAddItems, eventMessage, organizerRadioButton
            })
        }

        /* clears out any formError or PicAppError error upon remount*/
        if (this.state.form) {this.setState({formError: ''})};
        if (this.props.picapp.error) {this.props.clearPicAppError()}
     }


    onEventTitleChange = (e) => {
        const eventTitle = e.target.value;     // assign input value to local var; allows to use object shorthand on next line
        // if (!isEmpty(this.props.picapp.selected)) {
        //     this.setState(() => ({ eventTitle, editMode: true })); // update value on local state using ES6 shorthand
        // } else {
            // this.setState(() => ({ eventTitle, editMode: false }));
            this.setState(() => ({ eventTitle }));
        // }
        // this.setState(
        //     { eventTitle: e.target.value },
        //     () => { console.log(`${this.state.eventTitle}`) }
        // );
    };

    onLocationChange = (e) => {
        const location = e.target.value;   // assign input value to local var; allows to use object shorthand on next line
        this.setState(() => ({ location })); // update value on local state using ES6 shorthand
    };

    /* Everytime user sets start date, it applies the time that is on the startTime Date field to the start Date.
       It also applies the date part from start date to the startTime field . If this is the first time start date
       is getting set, it will also apply the start date component to end date and end time. */
    handleStartDateChange = (startDate) => {
        // console.log("============= INSIDE START DATE CHANGE ==============");

        /* When date changes, four things should happen first time around to keep start and end date/times in sync.
           All other times only updates in item 1 and 2 are needed  */

        /* Here we sync up start date and start time */
        /* Uupdate time component of start date with time component of start time. */
        let startTimeField =  new Date(this.state.startTime);
        let startDateField =  new Date(startDate);
        let startDateObject = copyTimePart(startTimeField, startDateField);

        /* Update date component of start time with date component of start date. */
        startDateField =  new Date(startDate);
        startTimeField =  new Date(this.state.startTime);
        let startTimeObject = copyDatePart(startDateField, startTimeField);

        // console.log("============================================")
        // console.log("HandleStartDateChange - start info ")
        // console.log("Start Date ", startDateObject);
        // console.log("Start Time ", startTimeObject);

        if (this.state.matchEndDatetoStartDate) {
        /* Here we sync up end date and end time to match date component of start date, first time only*/
            /* Update date component of end date with date component of start date. */
            startDateField =  new Date(startDate);
            let endDateField =  new Date(this.state.endDate);
            var endDateObject = copyDatePart(startDateField, endDateField);

            /* Update date component of end time with date component of start date. */
            let startDateField =  new Date(startDate);
            let endTimeField =  new Date(this.state.endTime);
            var endTimeObject = copyDatePart(startDateField, endTimeField);
            // console.log("HandleStartDateChange - syncing end date with start date ")
            // console.log("End   Date ", endDateObject);
            // console.log("End   Time ", endTimeObject);

        }

        // Assuming that most events will occur on a single day, This logic makes end date same as start date when initially mounted
        // and when user sets the start date for first time.. After that one time, user would have to adjust end date themselves.
        if (this.state.matchEndDatetoStartDate) {
            // console.log("inside match start and end block");
            // console.log("this is start date object ", startDateObject);
            this.setState({ startDate: startDateObject, startTime: startTimeObject,
                            endDate:   endDateObject,   endTime:   endTimeObject,
                            matchEndDatetoStartDate: false     /* Here disable flag to sync up end date/time with start date/time */
            });
        } else {
            // console.log("NOT inside match start and end block");
            // console.log("this is start date object ", startDateObject);
            this.setState({ startDate: startDateObject,
                            startTime: startTimeObject
            });
        }
        // this.setState(
        //     { startDate },
        //     () => { console.log(`selected Start date ${this.state.startDate}`) }
        // );
    }

    /* Everytime user sets start time, it applies the time component to the startDate  */
    handleStartTimeChange = (startTime) => {


        /* update start date with time component of start time */
        let startTimeField = new Date(startTime);
        let startDateField = new Date(this.state.startDate);

        let startDateObject = copyTimePart(startTimeField, startDateField)

        // console.log("============================================")
        // console.log("HandleStartTimeChange - start info ")
        // console.log("Start Date ", startDateObject);
        // console.log("Start Time ", startTime);

        this.setState({ startTime: startTime, startDate: startDateObject });
    }

    /* Everytime user sets end date, copy the date component of endDate to endTime and
       copy the time component of time to the enddate*/
    handleEndDateChange = (endDate) => {
        console.log("============= INSIDE END DATE CHANGE ==============");
        console.log("This is endDate parameter passed in ", endDate)

        /* copy date component from end Date to end time */
        let endDateField = new Date(endDate);
        let endTimeField = new Date(this.state.endTime);
        console.log("This is endTime before change ", endTimeField)
        let endTimeObject = copyDatePart(endDateField, endTimeField)

        console.log("This is updated endTime  ", endTimeObject)

        console.log("This is endDate before change ", endDateField)
        /* copy time component from endTime to endDate */
        let endDateObject = copyTimePart(endTimeField, endDateField)

        console.log("This is endDate after change  ", endTimeObject)

        this.setState({ endDate: endDateObject, endTime: endTimeObject });
    }

    /* Everytime user change endTime, copy the time part from endTime to endDate */
    handleEndTimeChange = (endTime) => {
        console.log("============= INSIDE END TIME CHANGE ==============");
        /* Extract the day month and year from endDate Field */
        let endTimeField = new Date(endTime);
        let endDateField = new Date(this.state.endDate);

        let endDateObject = copyTimePart(endTimeField, endDateField)

        console.log("============================================")
        console.log("HandleEndTimeChange - start info ")
        console.log("This is endTime ", endTime);
        console.log("This is endDate ", endDateObject);

        this.setState({ endTime: endTime, endDate: endDateObject });
    }

    handleCheckboxClick = () => {
        this.setState({ allowAddItems: !this.state.allowAddItems });
    }

    handleRadioButton1 = () => {
        this.setState({
            organizerRadioButton: 1,
            organizer: ''
        });
    }

    handleRadioButton2 = (event) => {
        this.setState({
            organizerRadioButton: 2,
            organizer: event.target.value
        });

    }

    // Called when user selects radiobutton to enter another organzier name other than their own user name
    handleChangeOrganizer = (event) => {
        this.setState({
            organizer: event.target.value
        });
    }

    handleEventMessageChange = (event) => {
        this.setState({
            eventMessage: event.target.value
        });
    }

    // This handler is fired when user clicks on the X located to the right
    // of success message box
    handleHideSuccessMessage = () => {
        this.props.showSuccessMessage(false);
    }

    handleOnClickBackButton = (e) => {
        e.preventDefault();
        history.push("/");
    }

    handleOnClickHomeIcon = () => {
        history.push("/dashboard");
    }


    /* IMPORTANT: See comments on the onSubmit method */
    handleOnClickSaveButton = () => {

        console.log("*****************************************")
        console.log("******   INSIDE CLICK SAVE BUTTON *******")
        console.log("*****************************************")

        /* get organizers first name and last name */
        let firstname = this.props.auth.user.firstname;
        let lastname = this.props.auth.user.lastname;

        let saveAndNext = false;
        // If there is event already selected, issue the upsert along with the Ojbect Id
        // in order to do update in place, otherwise, we assume we are creating a new event.
        let { active: activeEvent   } = this.props.event;

        /* NOTE: this is only place we use id instead of _id as part of upsert */
        if (!isEmpty(activeEvent)) {
            var id  = activeEvent._id;
        }

        /* get values submitted on form that are saved in component state */
        let { email, eventTitle, location, timezone,
            startDate, startTime, endDate, endTime,
            eventCreator, organizer, allowAddItems, eventMessage
        } = this.state;

        console.log("START DATE ",  new Date(this.state.startDate))
        console.log("START TIME ",  new Date(this.state.startTime))
        console.log("END   DATE ",  new Date(this.state.endDate))
        console.log("END   TIME ",  new Date(this.state.endTime))

        // If form has no validation errors, kick off action to save event info,
        // If save was successful clear any app errors that may have posted on redux store
        // from the async ation itself.
        let eventInfoObject = {};
        if (this.isValidForm()) {
            // construct eventInfoObject; if id exist object will act as an update, otherwise
            // it will be an insert (no id specified); NOTE that this is the only place
            // (the upsert to database) where id is used (without the underscore). Since the
            // redux store will store id as  _id. all other pages should look for _id.
            id  ? eventInfoObject = { id, email, eventTitle, location, timezone,
                        startDate, endDate, startTime, endTime,
                        eventCreator, organizer, allowAddItems, eventMessage,
                        firstname, lastname, emailRemindersSent: false
                  }
                : eventInfoObject = { email, eventTitle, location, timezone,
                        startDate, endDate, startTime, endTime,
                        eventCreator, organizer, allowAddItems, eventMessage,
                        firstname, lastname, emailRemindersSent: false
                  }

            this.props.startSaveEventInfo(eventInfoObject, saveAndNext);
        };
    }


    // Note: this local onSubmit method does form validation, and dispatches the
    // action (startSaveEventInfo) responsible for saving event info form submission
    // IMPORTANT: This onSubmit method is duplicated in the handleOnClickSaveButton method,
    // with the only difference being the SaveAndNext flag being either true or false.
    onSubmit = (e) => {
        // let self = this;
        e.preventDefault();

        let saveAndNext = true;

        /* get organizers first name and last name */
        let firstname = this.props.auth.user.firstname;
        let lastname = this.props.auth.user.lastname;

        // If there is event already selected, issue the upsert along with the Ojbect Id
        // in order to do update in place, otherwise, we assume we are creating a new event.
        let { active: activeEvent   } = this.props.event;

        /* NOTE: this is only place we use id instead of _id as part of upsert */
        if (!isEmpty(activeEvent)) {
            var id  = activeEvent._id;
        }

        /* get values submitted on form that are saved in component state */
        let { email, eventTitle, location, timezone,
            startDate, startTime, endDate, endTime,
            eventCreator, organizer, allowAddItems, eventMessage
        } = this.state;

        // If form has no validation errors, kick off action to save event info,
        // If save was successful clear any app errors that may have posted on redux store
        // from the async ation itself.
        let eventInfoObject = {};
        if (this.isValidForm()) {
            // construct eventInfoObject; if id exist object will act as an update, otherwise
            // it will be an insert (no id specified); NOTE that this is the only place
            // (the upsert to database) where id is used (without the underscore). Since the
            // redux store will store id as  _id. all other pages should look for _id.
            id  ? eventInfoObject = { id, email, eventTitle, location, timezone,
                        startDate, endDate, startTime, endTime,
                        eventCreator, organizer, allowAddItems, eventMessage,
                        firstname, lastname, emailRemindersSent: false
                  }
                : eventInfoObject = { email, eventTitle, location, timezone,
                        startDate, endDate, startTime, endTime,
                        eventCreator, organizer, allowAddItems, eventMessage,
                        firstname, lastname, emailRemindersSent: false
                  }
            let saveAndNext = true;
            this.props.startSaveEventInfo(eventInfoObject, saveAndNext);
        };
    };


    // Render is operating from one version of the truth - - the local component state.
    // The only time we check local storage for an active event is in componenentDidMount
    // ComponentDidMount is responsible for copying properties from local storage to local state
    render() {
        const {classes } = this.props;  /* required for popup */
        // let  { startDate, startTime, endDate, endTime } = this.state;

        let { email, eventTitle, location,
            startDate, startTime, endDate, endTime,
            eventCreator, organizer, allowAddItems, eventMessage
        } = this.state;

        // Note, tab-selection-panel is in the -pic-mui-tabs.scss file
        return (
            <div className="tab-selection-panel">
                <form className="form-event-info" onSubmit={this.onSubmit}>
                    {this.displayError()}
                    <div className="form__label-field-combo-top">
                        <label className="form__eventinfo-form-label" htmlFor="title">Event Title</label>
                        <input
                            type="text"
                            placeholder=""
                            className="form__field--large2"
                            onChange={this.onEventTitleChange}    // change the state.email value via change method
                            value={eventTitle}                    // render component with value from state
                            maxLength="50"
                        />
                    </div>
                    <div className="form__label-field-combo-top">
                        <label className="form__eventinfo-form-label" htmlFor="location">Location</label>
                        <input
                            type="text"
                            placeholder=""
                            className="form__field--large2"
                            value={location}
                            onChange={this.onLocationChange}
                            maxLength="85"
                        />
                    </div>
                    <div className="datetime-container">
                        <MuiThemeProvider theme={theme}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <div className="datetime-pair">
                                <DatePicker
                                    label="Event Date"
                                    value={startDate}
                                    onChange={this.handleStartDateChange}
                                    animateYearScrolling
                                />
                                <div className="eventinfo-ml-s" >
                                    <TimePicker
                                        autoOk
                                        label="Start Time"
                                        value={startTime}
                                        onChange={this.handleStartTimeChange}
                                    />
                                </div>
                            </div>

                            <div className="datetime-to-literal">to</div>

                            <div className="datetime-pair">
                                <TimePicker
                                    autoOk
                                    label="End Time"
                                    value={endTime}
                                    onChange={this.handleEndTimeChange}
                                />
                                <div className="eventinfo-ml-s" >
                                    <DatePicker
                                        className="eventinfo-ml-s"
                                        label="End Date"
                                        value={endDate}
                                        onChange={this.handleEndDateChange}
                                        animateYearScrolling
                                    />
                                </div>
                            </div>
                            </MuiPickersUtilsProvider>
                        </MuiThemeProvider>
                    </div>
                    <div className="eventinfo-radio-group-title">
                        Organizer Name
                        <p className={"eventinfo-radio-group-subtitle"}>(Will appear as "From" organizer on the invite)</p>
                    </div>
                    <div className="eventinfo-radio-group">
                        <label className="eventinfo-radio-text-pair">
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                            <input className="eventinfo-radio-button-creator"
                                type="radio"
                                value={this.state.eventCreator}
                                checked={this.state.organizerRadioButton === 1}
                                onChange={this.handleRadioButton1}
                            />
                            <p className="eventinfo-radio-text">{this.state.eventCreator}</p>
                            </div>
                        </label>
                        <label className="eventinfo-radio-text-pair">
                            <input  className="eventinfo-radio-button-other"
                                type="radio"
                                value={organizer}
                                checked={this.state.organizerRadioButton === 2}
                                onChange={this.handleRadioButton2}
                            />
                            <div>&nbsp;</div>
                            <div className="eventinfo-radio-input">
                            <input className="eventinfo-radio-input"
                                type="text"
                                onChange={this.handleChangeOrganizer}    // funtion to set orginizer name
                                placeholder="Other (eg. Westlake PTA)"
                                value={organizer}         // render component with value from state object
                                maxLength="50"
                            />
                            </div>
                        </label>
                        {/* <div  className="eventinfo-checkbox-container">
                            <input  className="eventinfo-checkbox"
                                id="checkbox1"
                                value="yes"
                                name="allowAddItems"
                                type="checkbox"
                                checked={this.state.allowAddItems}
                                onChange={() => this.handleCheckboxClick()}
                            />
                            <span className="eventinfo-checkBoxText">
                                Allow Participants to add items to your list
                            </span>
                        </div> */}
                    </div>
                    <div>&nbsp;</div>
                    <div className="eventinfo-texarea-container">
                        <div className="eventinfo-textarea-title">Message
                            <span className="eventinfo-textarea-subtitle">(Message you would like to send with email invite)</span>
                        </div>
                        <textarea
                          placeholder=""
                          className="eventinfo-textarea-input"
                          onChange={this.handleEventMessageChange}    // change the state.description value
                          value={eventMessage}         // render component with value from state object
                          maxLength="430"
                        >
                    </textarea>
                </div>

            {/*
                <div className="eventinfo-buttons-container">
                    <ShadowButton  buttonText="Back" words={1} onClickHandler={this.handleOnClickBackButton} />
                    <div className="rc-flex-container-center-hv">
                        <ShadowButton name="SaveButton" buttonText="Save" words={1} onClickHandler={this.handleOnClickSaveButton} type="button" />
                        <div>&nbsp;</div>
                        <SimpleButton buttonText="Save / Next" words={2} type="submit" />
                    </div>
                </div>
            */}
                    <div className="eventinfo-buttons-container">
                        <div className="eventinfo-back-button-container">
                            <ShadowButton  buttonText="Back" words={1} onClickHandler={this.handleOnClickBackButton} />
                            <div className='eventinfo-modifier-plr1' >
                                <div onClick={this.handleOnClickHomeIcon}><HomeIcon /></div>
                            </div>
                        </div>
                        <div className="invite-right-buttons-container">
                            <ShadowButton name="SaveButton" buttonText="Save" words={1} onClickHandler={this.handleOnClickSaveButton} type="button" />
                            <div>&nbsp;</div>
                            <SimpleButton buttonText="Save / Next" words={2} type="submit" />
                        </div>
                    </div>
                </form>
            </div>
        )
    }

    // If there is an auth error on the redux store, clear it before unmounting compoment
    componentWillUnmount() {
        if (this.props.auth.error) {
            this.props.clearAuthError();
        }
     }


    // It will check if a local form error exist first, and render error message.
    // If not, it checks if app error exist (that may have been triggered by event info action).
    // If found, it renders the app error
    displayError = () => {
        // console.log(`THIS IS PIC APP ERROR |${this.props.picapp.error}|`);
        if (this.state.formError) {

            let messageArray = this.state.formError.split(': ');
            let [ messageLabel, message ] =  messageArray;

            return  <p className="pic-error">
                        <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle} />
                        <span className="pic-err-msg-label">{`${messageLabel}: `}</span>
                        <span className="pic-err-msg">{message}</span>
                    </p>

        } else if (this.props.picapp.error) {

            let messageArray = this.props.picapp.error.split(': ');
            let [ messageLabel, message ] =  messageArray;

            return  <p className="pic-error">
                        <FontAwesomeIcon className="warning-icon" icon={faExclamationTriangle} />
                        <span className="pic-err-msg-label">{`${messageLabel}: `}</span>
                        <span className="pic-err-msg">{message}</span>
                    </p>

        } else {
            return <p className="pic-error-filler">&nbsp;</p>
        }
    }


    // TODOS - do follow validation
    // 1) Check that an event title is provided
    // 2) Check that an event location is provided
    // 3) Check that event start date is on or after current date.
    // 4) If event is on a single day, make sure start time  and end time are not the same
    // 5) If event is on a single day, check that end time is not before start time
    // 6) If event is more than one day, check that start date is before end date
    // 7) All validations passed; clear error statement
    isValidForm = () => {
        let valid = false;

        // let { startTime, endTime, startDate, endDate, eventMessage } = this.state;


        // let { selected   } = this.props.picapp;
        // if (!isEmpty(selected)) {
        //     console.log("IS SELECTED");
        //     var { email, eventTitle, location,
        //         startDate, startTime, endDate, endTime,
        //         eventCreator, organizer, allowAddItems, eventMessage
        //     } = this.props.picapp.selected.eventInfo;
        // } else {
            var { email, eventTitle, location,
                startDate, startTime, endDate, endTime,
                eventCreator, organizer, allowAddItems, eventMessage
            } = this.state;
        // }


        // Let "today" be set to the start of the day. This prevents the (startDate isBefore today)
        // test from failing if user selects event the same day as today. This will allow user to create an
        // event in the morning for later in the afternoon or evening of the same day.
        let today = new Date();
        today = startOfDay(today);

        if (!eventTitle) {                                                   // case#1
            this.setState(() => ({ formError: 'Missing something: Please provide Event Title '}))
        } else if (!location) {                                              // case#2
            this.setState(() => ({ formError: 'Missing something: Please provide a Location for event'}))
        } else if (isBefore(startDate, today))    {                             // case#3
            this.setState(() => ({ formError: 'Please Check Dates: Your "Event Date" seems to be in the past. '}))
        } else if (isSameDay(startDate, endDate)  &&                    // case#4
                   isSameHour(startTime, endTime) &&
                   isSameSecond(startTime, endTime)) {
            this.setState(() => ({ formError: 'Please Check Times: both the "Start" and "End Time" are at the same time"'}))
        } else if (isSameDay(startDate, endDate)  &&                    // case#5
            (differenceInHours(startTime, endTime) < 1) ) {
            this.setState(() => ({ formError: 'Please Check Times: "Start Time" may be in the past or later than "End Time" '}))
        } else if ( !isSameDay(startDate, endDate)  &&                  // case#6
                    isBefore(endDate, startDate )) {
            this.setState(() => ({ formError: 'Please Check Dates: Your "End Date" is before your "Event Date (start)"'}))
        } else if (!eventMessage) {                                              // case#2
            this.setState(() => ({ formError: 'Missing something: Please provide a message to send with your email invite'}))
        } else if (this.state.organizerRadioButton === 2 && !this.state.organizer) {                                              // case#2
            this.setState(() => ({ formError: 'Missing something: "Other" organizer name was not provided'}))
        } else {   // Clear the error when all validations passed                       // case#7
            this.setState(() => ({ formError: ''}));        // clear form error
            if (this.props.picapp.error) { this.props.clearPicAppError() }; // clear api error
            valid = true;
        }
        return valid;
    }
} // END OF REACT component

const mapStateToProps = (state) => {
    return {
        auth:   state.auth,
        picapp: state.picapp,
        event:  state.event
    };
};

const mapDispatchToProps = (dispatch) => ({
    startSaveEventInfo:     (eventInfoObject, saveAndNext) => dispatch(startSaveEventInfo(eventInfoObject, saveAndNext)),
    clearPicAppError:       () => dispatch(clearPicAppError()),
    showSuccessMessage:     (booleanvalue) => dispatch(showSuccessMessage(booleanvalue))
});


// ***** When using the withStyles HOC, this was the syntax that worked. ****
// export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PicEventInfo));

// W O R K S
// export default connect(mapStateToProps)(PicEventInfo);
export default connect(mapStateToProps, mapDispatchToProps)(PicEventInfo);

// export default connect()(PicEventInfo);

// ***** When using the withStyles HOC, these were alternatives that did now work ****
// export default withStyles(styles, { withTheme: true }(connect(mapStateToProps,mapDispatchToProps)(PicEventInfo));
// export default compose(
//     withStyles(styles, {
//       name: 'PicEventInfo',
//     }),
//     connect(),
//   )(PicEventInfo);

// SAVE BUTTON
// <div>
// <button className="eventInfo-save-button" aria-describedby="save-button" variant="contained">Save</button>
// </div>



// WEBPACK FOOTER //
// ./src/components/PicEventInfo.js